import { PermissionEnum } from '@creditsights/api-ui-web';
import { PageComponentsMap } from '../../models';
import { hideCSView } from '../../pages/Company/Company.logic';
import { DEFAULT_COMPANY_WIDGETS_ORDER_CONFIG } from '../../pages/Company/CompanyOverviewTab/CompanyOverviewTab.constants';
import { IssuerDto } from '../../services/dtos/issuer/issuer.dto';
import { useBreakpoint } from '../common';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';

const useGetColumnView = (company: IssuerDto, pageComponentsMap: PageComponentsMap): number => {
  const { isTabletPortrait, isDesktop } = useBreakpoint();
  const { data: userPermissions } = useFetchUserPermissions();

  if (isTabletPortrait) {
    return 1;
  }

  const { userSubscription } = userPermissions!;
  const defaultConfig = DEFAULT_COMPANY_WIDGETS_ORDER_CONFIG[userSubscription];
  const isRightSideWidgetPresent = () => {
    return defaultConfig.rightSideWidgets.some((widgetId) => {
      const pageComponent = pageComponentsMap[widgetId];
      return pageComponent && pageComponent.body;
    });
  };
  const threeColumnRightContainerWidgetExists = !hideCSView(company) || isRightSideWidgetPresent();
  const show3ColumnLayout =
    company.csCoverage &&
    userPermissions!.permissions.includes(PermissionEnum.RESEARCH) &&
    threeColumnRightContainerWidgetExists;

  if (isDesktop && show3ColumnLayout) {
    return 3;
  }
  return 2;
};
export default useGetColumnView;
